import { styled, Typography as MuiTypography } from "@mui/material";

// Reusable typography style objects
export const typographyStyles = {
    h1: {
        fontFamily: "var(--font-family)",
        fontWeight: "var(--heading-h1-semibold-font-weight)",
        fontSize: "var(--heading-h1-font-size)",
        lineHeight: "var(--heading-h1-line-height)",
    },
    h2: {
        fontFamily: "var(--font-family)",
        fontWeight: "var(--heading-h2-semibold-font-weight)",
        fontSize: "var(--heading-h2-font-size)",
        lineHeight: "var(--heading-h2-line-height)",
    },

    h3: {
        fontFamily: "var(--font-family)",
        fontWeight: "var(--heading-h3-semibold-font-weight)",
        fontSize: "var(--heading-h3-font-size)",
        lineHeight: "var(--heading-h3-line-height)",
    },
    h4: {
        fontFamily: "var(--font-family)",
        fontWeight: "var(--heading-h4-semibold-font-weight)",
        fontSize: "var(--heading-h4-font-size)",
        lineHeight: "var(--heading-h4-line-height)",
    },
    p1: {
        fontFamily: "var(--font-family)",
        fontWeight: "var(--paragraph-p1-regular-font-weight)",
        fontSize: "var(--paragraph-p1-font-size)",
        lineHeight: "var(--paragraph-p1-line-height)",
    },
    p2: {
        fontFamily: "var(--font-family)",
        fontWeight: "var(--paragraph-p2-regular-font-weight)",
        fontSize: "var(--paragraph-p2-font-size)",
        lineHeight: "var(--paragraph-p2-line-height)",
    },
};

// Styled Typography components
export const H1 = styled(MuiTypography)(() => typographyStyles.h1);
export const H2 = styled(MuiTypography)(() => typographyStyles.h2);
export const H3 = styled(MuiTypography)(() => typographyStyles.h3);
export const H4 = styled(MuiTypography)(() => typographyStyles.h4);
export const P1 = styled(MuiTypography)(() => typographyStyles.p1);
export const P2 = styled(MuiTypography)(() => typographyStyles.p2);
